<template>
    <header>
        <div class="container nav">
            <a class="header__logo" href="https://www.pixnet.net/" target="_blank">
                <img src="@/assets/images/logo.svg" alt="痞客邦" />
                <h1>2024 社群金點賞</h1>
            </a>
            <svg class="ham hamRotate for-mobile" viewBox="0 0 100 100" width="40" :class="{ 'active': hamStatus }"
                @click="hamStatus = !hamStatus">
                <path class="line top"
                    d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
                <path class="line middle" d="m 30,50 h 40" />
                <path class="line bottom"
                    d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
            </svg>

            <ul :class="{ 'action': hamStatus }">
                <li @click="scrolltoBlock('aboutPixStar')">關於社群金點賞</li>
                <li @click="scrolltoBlock('selection')">評選說明</li>
                <li @click="scrolltoBlock('winners')">百大部落客得獎名單</li>
            </ul>
        </div>
    </header>
</template>

<script setup>
import { ref } from 'vue';

const hamStatus = ref(false);

const HEADER_HEIGHT = 64;

const scrolltoBlock = block => {
    hamStatus.value = false;
    const goToBlock = document.querySelector(`#${block}`);
    if (!goToBlock) {
        window.scroll({
            top: document.querySelector(`.${block}`).offsetTop - HEADER_HEIGHT,
            behavior: 'smooth',
        });
        return;
    }
    window.scroll({
        top: (goToBlock.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT),
        behavior: 'smooth',
    })
}

</script>

<style lang="scss" scoped>
@import '@/styles/theHeader';
</style>